import { render, staticRenderFns } from "./AssetMenu.vue?vue&type=template&id=5ec7efa8&"
import script from "./AssetMenu.vue?vue&type=script&lang=js&"
export * from "./AssetMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports